<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal sts_installment_modal_str iu-modal"
    no-close-on-backdrop
    title="Edit Installment Details"
    @change="val => $emit('update:visible', val)"
  >
    <b-form-group
      label="Installment Amount"
      label-for="h-inst-amount"
    >
      <b-form-input
        id="h-inst-amount"
        :value="installmentAmount"
        disabled
        placeholder="Installment Amount"
      />
    </b-form-group>

    <b-form-group
      label="Tenure"
      label-for="h-inst-tenure"
    >
      <b-input-group
        append="months"
        class="appendMonth"
      >
        <b-form-input
          id="h-inst-tenure"
          v-model="installmentTenureValue"
          type="number"
          :disabled="!unlocked"
          placeholder="Tenure"
        />
      </b-input-group>
    </b-form-group>

    <b-form-group
      label="Mode of Payment"
      label-for="h-inst-mode"
    >
      <v-select
        id="h-inst-mode"
        v-model="installmentModeValue"
        :options="modeOptions"
        :clearable="false"
        :disabled="!unlocked"
      />
    </b-form-group>

    <b-form-group
      label="Monthly Installment"
      label-for="h-inst-monthly"
    >
      <b-form-input
        id="h-inst-monthly"
        v-model="monthlyInstallmentValue"
        type="number"
        :disabled="!unlocked"
        placeholder="Monthly Installment"
      />
    </b-form-group>

    <b-form-group
      label="Final Installment"
      label-for="h-inst-final"
    >
      <b-form-input
        id="h-inst-final"
        v-model="finalInstallmentValue"
        type="number"
        :disabled="!unlocked"
        placeholder="Final Installment"
      />
    </b-form-group>

    <b-form-checkbox
      v-model="unlocked"
      class="mb-1"
    >
      I have communicated to agent/customer and I wish to make changes to the fields above.
    </b-form-checkbox>

    <b-form-group
      label="Commencement Date"
      label-for="h-inst-due-date"
      class="calendar_sp_icon"
    >
      <flat-pickr
        id="h-inst-due-date"
        v-model="installmentDueDateValue"
        class="form-control"
        placeholder="Select from calendar"
        :disabled="!unlocked"
        :config="flatPickrConfig"
      />
      <feather-icon
        icon="CalendarIcon"
        class="calendar-icon"
        size="16"
      />
    </b-form-group>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BInputGroup, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BModal, BFormGroup, BFormInput, BInputGroup, BFormCheckbox, BButton, vSelect, flatPickr,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    installmentAmount: {
      type: Number,
      default: 0,
    },
    installmentTenure: {
      type: Number,
      default: 0,
    },
    installmentMode: {
      type: String,
      default: 'Via Counter or Mobile App',
    },
    monthlyInstallment: {
      type: Number,
      default: 0,
    },
    finalInstallment: {
      type: Number,
      default: 0,
    },
    // "DD/MM/YYYY" string.
    installmentDueDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      // Session-only gate, not persisted - resets to unchecked every time the modal opens, per the
      // "user needs to check this every time" behavior confirmed in the design.
      unlocked: false,
      installmentTenureValue: this.installmentTenure,
      installmentModeValue: this.installmentMode,
      monthlyInstallmentValue: this.monthlyInstallment,
      finalInstallmentValue: this.finalInstallment,
      installmentDueDateValue: this.installmentDueDate,
      // 'Direct Debit IPP'/'Giro/eGiro' must match REPAYMENT_ARRANGEMENT_MODES exactly
      // (backend helpers/sales-order-workflow.js) - that's what triggers the SO approval
      // workflow's step 7 (Setup re-payment arrangements). Without them here this mode could
      // only ever be set by the app, never by admin.
      modeOptions: ['Via Counter or Mobile App', 'Direct Debit via Credit Card', 'Direct Debit IPP', 'Giro/eGiro'],
      flatPickrConfig: {
        dateFormat: 'd/m/Y',
        disableMobile: true,
      },
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.unlocked = false
        this.installmentTenureValue = this.installmentTenure
        this.installmentModeValue = this.installmentMode
        this.monthlyInstallmentValue = this.monthlyInstallment
        this.finalInstallmentValue = this.finalInstallment
        this.installmentDueDateValue = this.installmentDueDate
      }
    },
  },
  methods: {
    save() {
      this.$emit('save', {
        installmentTenure: this.installmentTenureValue,
        installmentMode: this.installmentModeValue,
        monthlyInstallment: this.monthlyInstallmentValue,
        finalInstallment: this.finalInstallmentValue,
        installmentDueDate: this.installmentDueDateValue,
      })
    },
  },
}
</script>
